import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { submenu } from './sub.menu';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';
import { MenuItemsModel } from '@core/menu/menu.model';
import { UserDetailResolverService } from './shared/services/user/user-detail-resolver.service';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { PartnerComponent } from './features/partners/partner/partner.component';
import { PartnersComponent } from './features/partners/list/partners.component';

const dataPrivilege: Record<'moduleMenu', MenuItemsModel[]> = {
    moduleMenu: submenu,
};

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Users,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Users + '/' + RouteEntity.Add,
        title: marker('modules.users.head'),
        loadComponent: () => import('./features/user/user.component').then((c) => c.UserComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Users + '/:' + RoutingQueryParamsName.UsrId,
        title: marker('modules.users.head'),
        loadComponent: () => import('./features/user/user.component').then((c) => c.UserComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
        resolve: {
            user: UserDetailResolverService,
        },
    },
    {
        path: RouteEntity.Users,
        title: marker('modules.users.head'),
        loadComponent: () => import('./features/users/users.component').then((c) => c.UsersComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Divisions,
        title: marker('modules.divisions.head'),
        loadComponent: () => import('./features/divisions/divisions.component').then((c) => c.DivisionsComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.OrgRoles,
        title: marker('modules.orgRoles.head'),
        loadComponent: () => import('./features/org-roles/org-roles.component').then((c) => c.OrgRolesComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Partners,
        title: marker('modules.partners.head'),
        loadChildren: () => [
            {
                path: RouteEntity.Add,
                component: PartnerComponent,
            },
            {
                path: ':' + RoutingQueryParamsName.OrgId,
                component: PartnerComponent,
            },
            {
                path: RouteEntity.Empty,
                component: PartnersComponent,
            },
        ],
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
